module.exports = __webpack_public_path__ + "img/icon_red_zl.de9df335.png";